module.exports = __webpack_public_path__ + "img/IMG_1340.20d8e5ba.png";